/* eslint-disable no-console */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { useLanguage } from '../general/LanguageSelector.js';
import cardSwitchIcon from '../general/media/icons/cardSwitch.svg';
import heartIcon from '../general/media/icons/heart.svg';
import AlumniBack from './AlumniBack.js';
import AlumniFront from './AlumniFront.js';
import CompaniesBack from './CompaniesBack.js';
import CompaniesFront from './CompaniesFront.js';
import LecturerBack from './LecturerBack.js';
import LecturerFront from './LecturerFront.js';
import SwipeCard from './SwipeCard.js';
import * as cardData from './data/data.js';
import * as cardDataEn from './data/data-en.js';
import * as cardDataEs from './data/data-es.js';

const SwipeContainer = ({
  cardType,
  currentIndex,
  onSwipe,
  swipeRef,
  returningCard,
  showStart,
  isFavoritesOpen,
  isToggled,
  toggleFavorites,
  toggleCardSwitch,
}) => {
  const { selectedLanguage } = useLanguage();
  const [data, setData] = useState([]);
  const [arrayLength, setArrayLength] = useState(0);

  useEffect(() => {
    const loadData = async () => {
      let dataModule;
      try {
        switch (selectedLanguage) {
          case 'en':
            dataModule = cardDataEn;
            break;
          case 'es':
            dataModule = cardDataEs;
            break;
          case 'de':
            dataModule = cardData;
            break;
          default:
            dataModule = cardData;
            break;
        }
      } catch (error) {
        console.error(
          `Failed to load data for language ${selectedLanguage}, falling back to default data`,
          error,
        );
        dataModule = cardData;
      }

      let newData;
      try {
        switch (cardType) {
          case 'lecturers':
            newData = dataModule.lecturers;
            break;
          case 'alumni':
            newData = dataModule.alumni;
            break;
          case 'companies':
            newData = dataModule.companies;
            break;
          default:
            newData = dataModule.companies;
            break;
        }
      } catch (error) {
        console.error(
          `Failed to load data for card type ${cardType}, using fallback data`,
          error,
        );
        newData = dataModule.companies; // Use fallback data in case of error
      }

      setData(newData);
      setArrayLength(newData?.length);
    };

    loadData();
  }, [cardType, selectedLanguage]);

  const visibleItems = data.slice(currentIndex, currentIndex + 3);
  const returningIndex = visibleItems.findIndex(
    (item) => item && returningCard && item.id === returningCard.id,
  );

  return (
    <div className='swipe-container'>
      {visibleItems.map((item, index) => (
        /**
         * SwipeCard Component
         *
         * @param {Object} props - Component properties
         * @param {boolean} props.showStart - Boolean indicating if the start screen should be shown
         * @param {boolean} props.isFavoritesOpen - Boolean indicating if the favorites section is open
         * @param {boolean} props.isToggled - Boolean indicating if the card switch is toggled
         * @param {React.Component} props.FrontComponent - Front side component of the swipe card
         * @param {React.Component} props.BackComponent - Back side component of the swipe card
         * @param {Object} props.item - The data item to be displayed on the card
         * @param {number} props.index - The index of the card in the list
         * @param {Function} props.onSwipe - Function called when a card is swiped
         * @param {boolean} props.showOverlay - Boolean indicating if the green/red overlay should be shown
         * @param {Object} props.ref - Reference to the swipeable card component
         * @param {boolean} props.isReturning - Boolean indicating if the card is returning to the deck
         * @param {number} props.arrayLength - The total number of cards in the array
         * @param {number} props.position - The position of the card in the array
         *
         * @returns {JSX.Element} SwipeCard component
         */
        <SwipeCard
          showStart={showStart}
          isFavoritesOpen={isFavoritesOpen}
          isToggled={isToggled}
          key={item.id}
          FrontComponent={
            cardType === 'lecturers'
              ? LecturerFront
              : cardType === 'alumni'
                ? AlumniFront
                : CompaniesFront
          }
          BackComponent={
            cardType === 'lecturers'
              ? LecturerBack
              : cardType === 'alumni'
                ? AlumniBack
                : CompaniesBack
          }
          item={item}
          index={index}
          onSwipe={onSwipe}
          showOverlay={cardType === 'companies'}
          ref={index === 0 ? swipeRef : null} // Reference only for the top card
          isReturning={index === returningIndex} // Add a prop to indicate if the card is returning
          arrayLength={arrayLength} // Pass total number of cards
          position={currentIndex + index + 1} // Pass the position of the card in the array
        />
      ))}
      <h3 className='allSwiped--heading'>Du hast alle Karten geswiped!</h3>
      <p className='allSwiped--text'>
        <span className='allSwiped--button' onClick={toggleCardSwitch}>
          <img src={cardSwitchIcon} /> Wechsel
        </span>{' '}
        doch auf die anderen Kategorien oder schaue dir deine
        <span className='allSwiped--button' onClick={toggleFavorites}>
          <img src={heartIcon} />
          Favoriten
        </span>{' '}
        an!
      </p>
    </div>
  );
};

export default SwipeContainer;
